module.exports = __webpack_public_path__ + "VIPH8.png?4851af1a9c32692beb4438a25d50ac64";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPH8.png
// module id = 101
// module chunks = 0